import { Link, useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Mail, ArrowRight, CheckCircle } from 'lucide-react';
import { LOGO_URL, BrandText } from '@/lib/brand';
import { useEffect } from 'react';

export default function VerifyRequest() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || 'your email';

  // Clear any stale auth tokens so user can access /login without redirect loop
  useEffect(() => {
    localStorage.removeItem('outplay_token');
    localStorage.removeItem('outplay_user');
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4" data-testid="verify-request-page">
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-50 via-background to-blue-50/30 dark:from-emerald-950/20 dark:via-background dark:to-blue-950/10" />
      <div className="relative w-full max-w-md text-center">
        <Link to="/" className="inline-flex items-center gap-2 mb-8">
          <img src={LOGO_URL} alt="Out-Play" className="h-10 w-10 rounded-xl object-cover" />
          <BrandText className="text-2xl tracking-tight" />
        </Link>

        <Card className="border shadow-lg">
          <CardContent className="p-10">
            <div className="h-16 w-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-5">
              <Mail className="h-8 w-8 text-emerald-600" />
            </div>
            <h2 className="text-xl font-display font-bold mb-2">Check Your Email</h2>
            <p className="text-sm text-muted-foreground mb-4">
              We've sent a verification link to:
            </p>
            <p className="text-base font-semibold text-primary mb-6 break-all">{email}</p>
            <div className="space-y-3 text-left mb-6">
              <div className="flex items-start gap-2 text-sm text-muted-foreground">
                <CheckCircle className="h-4 w-4 text-emerald-500 mt-0.5 flex-shrink-0" />
                <span>Click the verification link in the email</span>
              </div>
              <div className="flex items-start gap-2 text-sm text-muted-foreground">
                <CheckCircle className="h-4 w-4 text-emerald-500 mt-0.5 flex-shrink-0" />
                <span>Your 15-day free trial will activate automatically</span>
              </div>
              <div className="flex items-start gap-2 text-sm text-muted-foreground">
                <CheckCircle className="h-4 w-4 text-emerald-500 mt-0.5 flex-shrink-0" />
                <span>Check spam/promotions folder if you don't see it</span>
              </div>
            </div>
            <Link to="/login">
              <Button variant="outline" className="w-full">
                Go to Login <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </CardContent>
        </Card>

        <p className="text-xs text-muted-foreground mt-4">
          Didn't receive the email? Try signing up again or contact <a href="mailto:contact@out-play.in" className="text-primary hover:underline">contact@out-play.in</a>
        </p>
      </div>
    </div>
  );
}
